import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import axiosConfig from '../../config/axios';

export default function ContactUs() {
  const [form, setForm] = useState({
    first_name: '',
    last_name: '',
    email: '',
    phone_number: '',
    message: '',
  });

  const { setSnackInfo } = useSelector(store => store.notificationsState);

  const handleFormChange = e => {
    setForm(form => ({
      ...form,
      [e.target.name]: e.target.value,
    }));
  };

  const [loading, setLoading] = useState(false);

  const handleSubmitMessage = async e => {
    e.preventDefault();
    setLoading(true);
    try {
      await axiosConfig.post('/send_support_email', form);
      setForm({
        first_name: '',
        last_name: '',
        email: '',
        phone_number: '',
        message: '',
      });
      setSnackInfo(info => ({
        ...info,
        open: true,
        severity: 'success',
        message:
          'Message Sent Successfully. A response will be made via the provided e-mail or phone',
        autoHideDuration: 10000,
        horizontal: 'right',
      }));
    } catch (error) {
      console.error(error);

      setSnackInfo(info => ({
        ...info,
        open: true,
        severity: 'error',
        message: error.response?.data.error_message,
        autoHideDuration: 10000,
        horizontal: 'right',
      }));
    }
    setLoading(false);
  };

  return (
    <div className="relative isolate bg-white h-full">
      <div className="mx-auto grid max-w-7xl grid-cols-1 lg:grid-cols-2 h-full">
        <div className="relative px-6 grid content-center lg:static lg:px-8 py-4">
          <div className="mx-auto max-w-xl lg:mx-0 lg:max-w-lg">
            <div className="absolute inset-y-0 left-0 -z-10 w-full overflow-hidden bg-gray-100 ring-1 ring-gray-900/10 lg:w-1/2">
              <svg
                className="absolute inset-0 h-full w-full stroke-gray-200 [mask-image:radial-gradient(100%_100%_at_top_right,white,transparent)]"
                aria-hidden="true"
              >
                <defs>
                  <pattern
                    id="83fd4e5a-9d52-42fc-97b6-718e5d7ee527"
                    width={200}
                    height={200}
                    x="100%"
                    y={-1}
                    patternUnits="userSpaceOnUse"
                  >
                    <path d="M130 200V.5M.5 .5H200" fill="none" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" strokeWidth={0} fill="white" />
                <svg x="100%" y={-1} className="overflow-visible fill-gray-50">
                  <path d="M-470.5 0h201v201h-201Z" strokeWidth={0} />
                </svg>
                <rect
                  width="100%"
                  height="100%"
                  strokeWidth={0}
                  fill="url(#83fd4e5a-9d52-42fc-97b6-718e5d7ee527)"
                />
              </svg>
            </div>
            <h2 className="text-3xl font-bold tracking-tight text-gray-900">
              Get in touch
            </h2>
            <p className="mt-6 text-lg leading-8 text-gray-600">
              Africasasa Events is a product of Ideas Come To Life Ltd. Talk to
              us about ticketing, events or any other questions and suggestions.
            </p>
            <dl className="mt-10 space-y-4 text-base leading-7 text-gray-600">
              <div className="flex gap-x-4">
                <dt className="flex-none">
                  <span className="sr-only">Address</span>
                  <span className="material-icons">&#xe0c8;</span>
                </dt>
                <dd>
                  Ideas Come To Life Ltd (ICTLife)
                  <br />
                  Block A-7, Rehema Place, Junction of Ngong Rd and Ring Road
                  Kilimani
                  <br />
                  Nairobi, Kenya
                </dd>
              </div>
              <div className="flex gap-x-4">
                <dt className="flex-none">
                  <span className="sr-only">Telephone</span>
                  <span className="material-icons">&#xe61d;</span>
                </dt>
                <dd>
                  <a
                    className="hover:text-gray-900"
                    href="tel:+254 718 484 065"
                  >
                    +254 718 484 065
                  </a>
                </dd>
              </div>
              <div className="flex gap-x-4 items-center">
                <dt className="flex-none">
                  <span className="sr-only">Email</span>
                  <span className="material-icons">&#xe0d0;</span>
                </dt>
                <dd>
                  <a
                    className="hover:text-gray-900"
                    href="mailto:info@ictlife.com"
                  >
                    info@ictlife.com
                  </a>
                </dd>
              </div>
            </dl>
            <div className="w-full flex justify-between mt-12 flex-wrap space-x-2">
              <a
                className="cursor-pointer space-x-2 items-center flex font-semibold text-sm twitter-icon"
                target="_blank"
                href="https://twitter.com/sasa_events"
                rel="noreferrer"
              >
                <TwitterIcon />
                <span>Twitter</span>
              </a>
              <a
                className="cursor-pointer space-x-2 items-center flex font-semibold text-sm text-[#833AB4] visited:text-[#833AB4]"
                target="_blank"
                href="https://www.instagram.com/africa_sasa_events/"
                rel="noreferrer"
              >
                <InstagramIcon />
                <span>Instagram</span>
              </a>
              <a
                className="cursor-pointer space-x-2 items-center flex font-semibold text-sm whatsapp-icon"
                target="_blank"
                href="https://api.whatsapp.com/send?phone=%2B254718484065"
                rel="noreferrer"
              >
                <WhatsAppIcon />
                <span>WhatsApp</span>
              </a>
              <a
                className="cursor-pointer space-x-2 items-center flex font-semibold text-sm facebook-icon"
                target="_blank"
                href="https://web.facebook.com/profile.php?id=100090878285441"
                rel="noreferrer"
              >
                <FacebookIcon />
                <span>Facebook</span>
              </a>
            </div>
          </div>
        </div>
        <form
          onSubmit={handleSubmitMessage}
          className="px-6 grid content-center lg:px-8 py-4"
        >
          <div className="mx-auto max-w-xl lg:mr-0 lg:max-w-lg">
            <div className="grid grid-cols-1 gap-x-8 gap-y-6 sm:grid-cols-2">
              <div>
                <label
                  htmlFor="first-name"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  First name *
                </label>
                <div className="mt-2.5">
                  <input
                    onChange={handleFormChange}
                    value={form.first_name}
                    type="text"
                    name="first_name"
                    id="first-name"
                    required
                    autoComplete="given-name"
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div>
                <label
                  htmlFor="last-name"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Last name
                </label>
                <div className="mt-2.5">
                  <input
                    onChange={handleFormChange}
                    type="text"
                    value={form.last_name}
                    name="last_name"
                    id="last-name"
                    autoComplete="family-name"
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="email"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Email *
                </label>
                <div className="mt-2.5">
                  <input
                    onChange={handleFormChange}
                    type="email"
                    name="email"
                    value={form.email}
                    id="email"
                    autoComplete="email"
                    required
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="phone-number"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Phone number
                </label>
                <div className="mt-2.5">
                  <input
                    onChange={handleFormChange}
                    type="tel"
                    name="phone_number"
                    value={form.phone_number}
                    id="phone-number"
                    autoComplete="tel"
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                  />
                </div>
              </div>
              <div className="sm:col-span-2">
                <label
                  htmlFor="message"
                  className="block text-sm font-semibold leading-6 text-gray-900"
                >
                  Message *
                </label>
                <div className="mt-2.5">
                  <textarea
                    onChange={handleFormChange}
                    name="message"
                    value={form.message}
                    id="message"
                    rows={4}
                    className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 focus:outline-none shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary sm:text-sm sm:leading-6"
                    required
                  />
                </div>
              </div>
            </div>
            <div className="mt-8 flex justify-end">
              <button
                type="submit"
                className="custom-button rounded lc"
                disabled={loading}
              >
                {loading ? 'Sending...' : 'Send'} message
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
